import React from 'react';

import { format, isValid, parseISO } from 'date-fns';
import * as Yup from 'yup';

import { defaultDatePickerFormat } from 'Helpers/dateUtils';

import LockClosedIcon from 'Assets/icons/lock-closed.svg';

export const LAG_DAYS_LIMIT = 365;

export const lagMessage = () => $t('Lag must be between {{min}} and {{max}} days.', { min: -LAG_DAYS_LIMIT, max: LAG_DAYS_LIMIT });

/** The one lag rule, shared by the form schema and the add row. */
export const lagSchema = () =>
    Yup.number().typeError(lagMessage()).integer(lagMessage()).min(-LAG_DAYS_LIMIT, lagMessage()).max(LAG_DAYS_LIMIT, lagMessage()).required(lagMessage());

/** "Venue: Olympic Park" for a sourced plan, "Central plan" for the central one. */
export const planLabel = (activity) => {
    const plan = activity?.plan;

    if (!plan) {
        return '';
    }

    return plan.source_type ? `${plan.source_type_label}: ${plan.name}` : plan.name;
};

/** The activity's name, or "Restricted activity" when the user may not see it. */
export const activityName = (activity) => (activity?.visible ? activity.description : $t('Restricted activity'));

export const formatLinkDate = (value) => {
    if (!value) {
        return '-';
    }

    const date = parseISO(String(value).substring(0, 10));

    return isValid(date) ? format(date, defaultDatePickerFormat) : '-';
};

export const LinkedActivityDates = ({ activity }) => (
    <span className="tw-whitespace-nowrap">
        {formatLinkDate(activity?.start_date)} &rarr; {formatLinkDate(activity?.target_completion_date)}
    </span>
);

export const LinkedActivityCell = ({ activity }) => {
    if (!activity?.visible) {
        return (
            <div className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-charcoal-60">
                <LockClosedIcon className="tw-w-4 tw-h-4 tw-shrink-0" />
                <span className="tw-italic">{$t('Restricted activity')}</span>
            </div>
        );
    }

    return (
        <div className="tw-flex tw-flex-col tw-min-w-0">
            <span className="tw-truncate tw-text-charcoal" title={activity.description}>
                {activity.description}
            </span>
            <span className="tw-truncate tw-text-xs tw-text-charcoal-60">{planLabel(activity)}</span>
        </div>
    );
};
